import { RefObject, useEffect } from "react";

export function useClickOutside<T extends HTMLElement | null>(
  ref: RefObject<T>,
  enable: boolean,
  onClick: (e: MouseEvent) => void,
) {
  useEffect(() => {
    if (!enable || !ref.current) return;
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as HTMLElement)) {
        onClick(event);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, enable, onClick]);
}
